'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp;

var _templateObject = _taggedTemplateLiteral(['\n  query ethAccounts(\n    $where: EthAccountWhereInput\n    $first:Int = 10\n  ){\n    objects: ethAccounts(\n      where: $where\n      first: $first\n    ){ \n      id\n      name\n      description\n      address\n      type\n      balance\n    }\n  }\n  '], ['\n  query ethAccounts(\n    $where: EthAccountWhereInput\n    $first:Int = 10\n  ){\n    objects: ethAccounts(\n      where: $where\n      first: $first\n    ){ \n      id\n      name\n      description\n      address\n      type\n      balance\n    }\n  }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ethereumjsUtil = require('ethereumjs-util');

var ethUtil = _interopRequireWildcard(_ethereumjsUtil);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MetamaskAccount = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(MetamaskAccount, _PrismaCmsComponent);

  function MetamaskAccount() {
    _classCallCheck(this, MetamaskAccount);

    return _possibleConstructorReturn(this, (MetamaskAccount.__proto__ || Object.getPrototypeOf(MetamaskAccount)).apply(this, arguments));
  }

  _createClass(MetamaskAccount, [{
    key: 'connect',
    value: function connect() {
      var _global = global,
          ethereum = _global.ethereum;

      if (typeof ethereum !== 'undefined') {
        ethereum.enable().catch(console.error);
      }
    }
  }, {
    key: 'connectAccount',
    value: function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee3(callback) {
        var _this2 = this;

        var _global2, ethereum, web3;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _global2 = global, ethereum = _global2.ethereum, web3 = _global2.web3;

                if (ethereum) {
                  _context3.next = 4;
                  break;
                }

                this.addError("Плагин Metamask не обнаружен");
                return _context3.abrupt('return');

              case 4:
                _context3.next = 6;
                return ethereum.enable().then(function (async) {
                  var from = ethereum.selectedAddress;

                  if (!from) {
                    return _this2.connect();
                  }

                  var message = "\n    \u0411\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0442\u044C Ethereum \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 " + from + ".\n\n    \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0443\u0441\u043F\u0435\u0445\u0430 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D \u043A \u0442\u0435\u043A\u0443\u0449\u0435\u043C\u0443 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0438 \u043C\u043E\u0436\u0435\u0442 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438.\n    ";
                  var msg = ethUtil.bufferToHex(new Buffer(message, 'utf8'));
                  var params = [msg, from];
                  var method = 'personal_sign';
                  web3.currentProvider.sendAsync({
                    method: method,
                    params: params,
                    from: from
                  }, function () {
                    var _ref2 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regenerator2.default.mark(function _callee2(err, result) {
                      var error, signature, queryFragments, _ref3, _ref3$EthAccountNoNes, EthAccountNoNestingFragment, _ref4, _ref4$signup, signup, signupInRequest, data, auth;

                      return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (!err) {
                                _context2.next = 3;
                                break;
                              }

                              _this2.addError(err);

                              return _context2.abrupt('return');

                            case 3:
                              error = result.error, signature = result.result;

                              if (!error) {
                                _context2.next = 7;
                                break;
                              }

                              console.error(result.error); // this.addError(error && error.message || "Неизвестная ошибка");

                              return _context2.abrupt('return');

                            case 7:
                              // else
                              queryFragments = _this2.context.queryFragments;
                              _ref3 = queryFragments || {}, _ref3$EthAccountNoNes = _ref3.EthAccountNoNestingFragment, EthAccountNoNestingFragment = _ref3$EthAccountNoNes === undefined ? 'fragment EthAccountNoNesting on EthAccount {\n              id\n              createdAt\n              updatedAt\n              name\n              description\n              address\n              type\n              source\n              bytecode\n              abi\n              balance\n            }' : _ref3$EthAccountNoNes;
                              _ref4 = _this2.context.query || {}, _ref4$signup = _ref4.signup, signup = _ref4$signup === undefined ? '\n              mutation ethConnectAuthAccount(\n                $data:EthRecoverPersonalSignatureDataInput!\n              ){\n                response: ethConnectAuthAccount(\n                  data:$data\n                ){\n                  success\n                  message\n                  errors{\n                    key\n                    message\n                  }\n                  data{\n                    ...EthAccountNoNesting\n                  }\n                }\n              }\n              \n              ' + EthAccountNoNestingFragment + '\n            ' : _ref4$signup;
                              signupInRequest = _this2.state.signupInRequest;

                              if (!signupInRequest) {
                                _context2.next = 13;
                                break;
                              }

                              return _context2.abrupt('return');

                            case 13:
                              _this2.setState({
                                signupInRequest: true
                              });

                              data = {
                                message: message,
                                signature: signature,
                                from: from
                              };
                              _context2.next = 17;
                              return _this2.mutate({
                                mutation: (0, _graphqlTag2.default)(signup),
                                variables: {
                                  data: data
                                }
                              }).then(function () {
                                var _ref5 = _asyncToGenerator(
                                /*#__PURE__*/
                                _regenerator2.default.mark(function _callee(r) {
                                  return _regenerator2.default.wrap(function _callee$(_context) {
                                    while (1) {
                                      switch (_context.prev = _context.next) {
                                        case 0:
                                          if (!callback) {
                                            _context.next = 3;
                                            break;
                                          }

                                          _context.next = 3;
                                          return callback();

                                        case 3:
                                          return _context.abrupt('return', r);

                                        case 4:
                                        case 'end':
                                          return _context.stop();
                                      }
                                    }
                                  }, _callee, _this2);
                                }));

                                return function (_x4) {
                                  return _ref5.apply(this, arguments);
                                };
                              }()).catch(function (error) {
                                console.error(error);
                                return error;
                              });

                            case 17:
                              auth = _context2.sent;

                              _this2.setState({
                                signupInRequest: false
                              });

                              return _context2.abrupt('return', auth);

                            case 20:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function (_x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }).catch(function (error) {
                  _this2.addError(error);

                  console.error(error);
                });

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function connectAccount(_x) {
        return _ref.apply(this, arguments);
      }

      return connectAccount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var output = null;
      var _global3 = global,
          ethereum = _global3.ethereum;
      var Grid = this.context.Grid;
      var _props$data = this.props.data,
          _props$data$objects = _props$data.objects,
          objects = _props$data$objects === undefined ? [] : _props$data$objects,
          loading = _props$data.loading,
          refetch = _props$data.refetch; // console.log("this.props.data", this.props.data);

      var items = void 0;

      if (objects && objects.length) {
        items = objects.map(function (n) {
          var id = n.id,
              address = n.address,
              name = n.name;
          return _react2.default.createElement(Grid, {
            key: id,
            item: true,
            xs: 12
          }, _react2.default.createElement('a', {
            href: 'https://etherscan.io/address/' + address,
            target: '_blank'
          }, address));
        });
      } else {
        if (!loading) {
          items = _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(Grid, {
            item: true,
            xs: 12
          }, _react2.default.createElement(_Button2.default, {
            variant: 'raised',
            size: 'small',
            onClick: function onClick(event) {
              _this3.connectAccount(refetch);
            }
          }, "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u0442\u044C Ethereum \u0430\u043A\u043A\u0430\u0443\u043D\u0442")), !ethereum ? _react2.default.createElement(Grid, {
            item: true,
            xs: 12
          }, _react2.default.createElement(_Typography2.default, {
            color: 'error'
          }, "\u041F\u043B\u0430\u0433\u0438\u043D Metamask \u043D\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D."), _react2.default.createElement(_Typography2.default, {
            collor: 'error'
          }, "\u0421\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u043F\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0435 \u043D\u0430 ", _react2.default.createElement('a', {
            href: 'https://metamask.io/',
            target: '_blank'
          }, "\u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u043C \u0441\u0430\u0439\u0442\u0435"), '.')) : null);
        }
      }

      output = _react2.default.createElement(Grid, {
        container: true,
        spacing: 8
      }, _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, _react2.default.createElement(_Typography2.default, {
        variant: 'subheading'
      }, "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0439 ethereum \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438.")), items);
      return _get(MetamaskAccount.prototype.__proto__ || Object.getPrototypeOf(MetamaskAccount.prototype), 'render', this).call(this, output);
    }
  }]);

  return MetamaskAccount;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes), _temp);
exports.default = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject))(function (props) {
  return _react2.default.createElement(MetamaskAccount, props);
});
module.exports = exports['default'];